import type { ServiceHandler } from "./storageHandlers";
import { setExtraAppValue } from "../../../../../features/ExtraApp/redux/slice";
import { ExtraAppValue } from "../../../../api/instances/extraAppApi/types";

export const ExtraAppService: ServiceHandler = {
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    listenerApi.dispatch(setExtraAppValue(value as ExtraAppValue));
  },
};
